import apiClient from 'api/common/common'
import { NoticeOneResponse, NoticeResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { AxiosResponse } from 'axios'

/**
 * お知らせ一覧API
 * @param request
 * @param callback
 */
export const noticeAPI = async (callback: (status: Status, result: NoticeResponse) => void) => {
  await apiClient.get('/notice').then((response: AxiosResponse<NoticeResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    callback(status, response.data)
  })
}

/**
 * お知らせ詳細API
 * @param request
 * @param callback
 */
export const noticeOneAPI = async (noticeId: number, callback: (status: Status, result: NoticeOneResponse) => void) => {
  await apiClient.get(`/notice/${noticeId}`).then((response: AxiosResponse<NoticeOneResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    callback(status, response.data)
  })
}
